<template>
    <div class="ah-page profile-page">
        <div class="page-header bottom-margin">
            <div class="ah-container ">
                <div class="title-row">
                    <div class="title">
                        <h1>個人資訊</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container ">
            <div class="ah-panel">
                <div class="panel-header small gray">
                    <div class="panel-title">個人資訊</div>
                </div>
                <div class="panel-body">
                    <div class="detail-block">
                        <table class="ah-basic-data-table" cellspacing="0" cellpadding="0" style="font-size: 11pt;">
                            <tr>
                                <th>帳號</th>
                                <td>{{ personalInfo.eml }}</td>
                            </tr>
                            <tr>
                                <th>姓名</th>
                                <td>{{ personalInfo.nam }}</td>
                            </tr>
                            <tr v-if="personalInfo.pJ_NO != null && personalInfo.pJ_NO != ''">
                                <th>專案代號 <ah-tip>用於建立專案時顯示於專案編號</ah-tip></th>
                                <td>{{ personalInfo.pJ_NO }}</td>
                            </tr>
                            <tr>
                                <th>直屬主管</th>
                                <td>{{ personalInfo.boS_NAM }}</td>
                            </tr>
                            <tr>
                                <th>下屬列表</th>
                                <td>{{ getSubordinate(personalInfo) }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="ah-panel">
                <div class="panel-header gray small">
                    <div class="panel-title">員工薪轉帳戶<ah-tip>請款人銀行收款帳戶、員工薪轉帳戶、或員工常用的其他銀行帳戶</ah-tip></div>
                    <div class="panel-action right">
                        <el-button size="small" @click="onBankAccountEditBtnClick" v-if="!isEditingBankAccount">修改</el-button>
                    </div>
                </div>
                <div class="panel-body">
                    <el-form ref="bankForm" :model="bankAccountInfo" label-width="180px" label-position="right" :rules="isEditingBankAccount ? bankEditRules : {}">
                        <el-form-item prop="stafF_BNK_BOO" label="銀行">
                            <ah-el-select-bank
                                v-model="bankAccountInfo.stafF_BNK_BOO"
                                :branch="bankAccountInfo.stafF_BNK_DOO"
                                @branchInput="bankAccountInfo.stafF_BNK_DOO = $event"
                                :disabled="!isEditingBankAccount"
                            ></ah-el-select-bank>
                        </el-form-item>
                        <el-form-item prop="stafF_BNK_TPC" label="戶名">
                            <el-input v-model="bankAccountInfo.stafF_BNK_TPC" placeholder="" :disabled="!isEditingBankAccount"></el-input>
                        </el-form-item>
                        <el-form-item prop="stafF_BNK_ACC" label="帳號">
                            <ah-el-input-bank-acc v-model="bankAccountInfo.stafF_BNK_ACC" :disabled="!isEditingBankAccount"></ah-el-input-bank-acc>
                        </el-form-item>
                        <el-form-item prop="pwd" label="登入密碼" v-if="isEditingBankAccount">
                            <el-input type="password" v-model="bankAccountInfo.pwd" style="max-width: 250px;"></el-input>
                        </el-form-item>
                        <center v-if="isEditingBankAccount">
                            <el-button type="" @click="cancelBankAccount">取消</el-button>
                            <el-button type="primary" class="primary-action" :loading="isSubmitting" @click="submitBankAccount">儲存</el-button>
                        </center>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc.vue';

export default {
    name: 'ProfilePage',
    components: {
        ahElSelectBank,
        ahElInputBankAcc,
    },
    data() {
        return {
            authorities: {},
            bankAccountInfo: {
                stafF_BNK_BOO: null,
                stafF_BNK_DOO: null,
                stafF_BNK_TPC: null,
                stafF_BNK_ACC: null,
                pwd: null,
            },
            personalInfo: {},
            pwd: null,
            isSubmitting: false,
            isEditingBankAccount: false,
            bankEditRules: {
                stafF_BNK_BOO: [
                    {
                        required: true,
                        message: '請選擇銀行',
                        trigger: 'change',
                    },
                ],
                stafF_BNK_TPC: [
                    {
                        required: true,
                        message: '請輸入戶名',
                        trigger: 'blur',
                    },
                ],
                stafF_BNK_ACC: [
                    {
                        required: true,
                        message: '請輸入帳號',
                        trigger: 'blur',
                    },
                ],
                pwd: [
                    {
                        required: true,
                        message: '請輸入登入密碼',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        ...mapGetters({ userSno: 'account/userSno' }),
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.$api({
                url: '/ProfilePage/GetProfile',
                method: 'GET',
            }).then((resp) => {
                console.log(resp.data);
                this.authorities = resp.data.authorities;
                this.bankAccountInfo = resp.data.bankAccountInfo;
                this.personalInfo = resp.data.personalInfo;
            });
        },
        onBankAccountEditBtnClick() {
            this.isEditingBankAccount = true;
        },
        cancelBankAccount() {
            this.isSubmitting = false;
            this.isEditingBankAccount = false;
        },
        submitBankAccount() {
            this.$refs.bankForm.validate((valid) => {
                if (valid) {
                    this.isSubmitting = true;

                    this.$api({
                        url: '/ProfilePage/UpdateBankAccount',
                        method: 'POST',
                        data: {
                            stafF_BNK_BOO: this.bankAccountInfo.stafF_BNK_BOO,
                            stafF_BNK_DOO: this.bankAccountInfo.stafF_BNK_DOO,
                            stafF_BNK_ACC: this.bankAccountInfo.stafF_BNK_ACC,
                            stafF_BNK_TPC: this.bankAccountInfo.stafF_BNK_TPC,
                            pwd: this.bankAccountInfo.pwd,
                        },
                    })
                        .then((resp) => {
                            console.log(resp);
                            this.isEditingBankAccount = false;
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });
                }
            });
        },
        getSubordinate(info) {
            return _.chain(info.subordinateOptions)
                .filter((o) => o.sno !== this.userSno)
                .map('nam')
                .join(', ');
        },
    },
};
</script>
<style lang="scss">
.company-info-setting {
    .el-tabs__header {
        margin-bottom: 25px;
    }

    .el-form {
        .el-form-item {
            max-width: 800px;
        }
    }

    .bank-row {
        @media (min-width: 992px) {
            width: 420px;
        }
    }
}
</style>
